import '@/shared/plugins/dayjs';
import '@/shared/plugins/vue-dompurify-html';
import '@/index/plugins/v-calendar';
import '@/shared/plugins/vue-enums';
import '@/index/plugins/vue-fragment';
import '@/shared/plugins/vue-accessibility-focus';
import deferredPlugin from '@/shared/plugins/deferred';
import eventsPlugin from '@/index/plugins/events';
import modalPlugin from '@/index/plugins/modal';
import servicesPlugin from '@/shared/plugins/services';
import spinnerPlugin from '@/shared/plugins/spinner';
import statsPlugin from '@/shared/plugins/stats';
import storagePlugin from '@/shared/plugins/storage';
import windowPlugin from '@/shared/plugins/window';
import routerPlugin from '@/index/plugins/router';
import sdkPlugin from '@/index/plugins/sdk';
import onetrustPlugin from '@/index/plugins/onetrust';
import resourcesPlugin from '@/shared/plugins/resources';
import sentryPlugin from '@/index/plugins/sentry';
import captchaPlugin from '@/index/plugins/captcha';
import chartbeatPlugin from '@/shared/plugins/chartbeat';
import freewheelPlugin from '@/shared/plugins/freewheel';
import gemiusPlugin from '@/shared/plugins/gemius/audience';
import gemiusStreamPlugin from '@/shared/plugins/gemius/stream';
import gtmPlugin from '@/shared/plugins/gtm';
import ipressoPlugin from '@/shared/plugins/ipresso';
import playerPlugin from '@/shared/plugins/player';
import smartadPlugin from '@/index/plugins/smartad';
import trackingPlugin from '@/shared/plugins/tracking';
import initPlugin from '@/index/plugins/init';

export default [
  deferredPlugin,
  eventsPlugin,
  modalPlugin,
  servicesPlugin,
  spinnerPlugin,
  statsPlugin,
  storagePlugin,
  windowPlugin,
  routerPlugin,
  sdkPlugin,
  onetrustPlugin,
  resourcesPlugin,
  sentryPlugin,
  captchaPlugin,
  chartbeatPlugin,
  freewheelPlugin,
  gemiusPlugin,
  gemiusStreamPlugin,
  gtmPlugin,
  ipressoPlugin,
  playerPlugin,
  smartadPlugin,
  trackingPlugin,
  initPlugin,
];
